import { LocalStorage, Notify } from 'quasar'
import { i18n } from 'src/boot/i18n'

export function ORDERS_TABLE_ORDERS_LOADING (state, status) {
  state.tableOrdersLoading = status
}

export function ORDERS_SET_DATA (state, data = false) {
  if (data) {
    data = Object.assign(state.data, data)
    state['data'] = data
    LocalStorage.set('order.data', data)
  } else {
    state['data'] = {}
    LocalStorage.remove('order.data')
  }
}

export function ORDERS_ADD_ITEMS (state, items) {
  state.current.set('item_orders', items)
}

export function ORDERS_LOADING (state, status) {
  state['loading'] = status
}

export function ORDERS_DESTROY (state, refresh = true) {
  state['orderId'] = false
  LocalStorage.remove('order.id')

  state['data'] = {}
  LocalStorage.remove('order.data')
  LocalStorage.remove('order.call_id')

  state['current'] = false
  if(state.subscription) {
    state.subscription.unsubscribe()
  }
  state['subscription'] = false
  state['socketUpdateFlag'] = false
  // state['waiterCall'] = false
  // state['waiterCallId'] = false
  state['hasWaiterCall'] = false
  state['loading'] = false

  if (refresh) {
    window.location.reload()
  }
}

export function ORDERS_UPDATED (state, order) {
  state['socketUpdateFlag'] = !state.socketUpdateFlag
  if (state.current && state.current.id && state.current.id === order.id) {
    state['current'] = order
  }
}

export function ORDERS_OBJECT_SET (state, order) {
  state['current'] = order
  state['orderId'] = order.id
  LocalStorage.set('order.id', order.id)
}

export function ORDERS_SUBSCRIPTION_ADD (state, subscription) {
  state['subscription'] = subscription
}

export function ORDERS_MODE_SET (state, mode) {
  state['mode'] = mode
  LocalStorage.set('order.mode', mode)
}

export function ORDERS_SAVE_ONE (state, order) {
  let found = false

  for (const i in state.all) {
    if (order.id === state.all[i].id) {
      found = true
      break
    }
  }

  if (!found) {
    state.all.push(order)
  }
}

export function ORDERS_REMOVE_ALL (state) {
  state['all'] = []
}

export function ORDERS_SET_ROLE (state, role) {
  state['role'] = role
}

export function ORDERS_SET_CLIENT_NAME (state, name) {
  LocalStorage.set('order.client_name', name)
  state['extra_client_name'] = name
}

export function ORDERS_SET_SHOW_POPUP (state, bool) {
  state['showClientNamePopup'] = bool
}

export function SHOW_REFUNDED (state, item) {
  state.refundeds[item.id] = item
}

export function SHOW_ACTIVES (state, payload) {
  state.showActives = payload
  LocalStorage.set('order.show_actives', payload)
}
export function DELETE_REFUNDED (state, itemId) {
  delete state.refundeds[itemId]
}

export function SET_CURRENT_PRICE(state, payload) {
  state.currentPrice = payload
}

export function SET_CART_PRICE(state, payload) {
  state.cartPrice = payload
}
